import type React from 'react';

import { TextField } from '@change/ds-forms';

export const NameInput: React.FC<{
	firstName: string;
	lastName: string;
	name: string;
	disabled: boolean;
	validationErrors: Record<string, string> | null;
	useSplitFields: boolean;
	labelName: string;
	labelFirstName: string;
	labelLastName: string;
	setFirstName: (firstName: string) => void;
	setLastName: (lastName: string) => void;
	setName: (name: string) => void;
	trackNameInputFocus: () => void;
	trackFirstNameInputFocus: () => void;
	trackLastNameInputFocus: () => void;
}> = ({
	firstName,
	lastName,
	name,
	disabled,
	validationErrors,
	useSplitFields,
	labelName,
	labelFirstName,
	labelLastName,
	setFirstName,
	setLastName,
	setName,
	trackNameInputFocus,
	trackFirstNameInputFocus,
	trackLastNameInputFocus,
}) => {
	if (useSplitFields)
		return (
			<div className="flex items-start gap-3">
				<div className="flex-1">
					<TextField
						name="input-first-name"
						errorMessage={validationErrors?.firstName}
						isInvalid={!!validationErrors?.firstName}
						validationBehavior="aria"
						label={labelFirstName}
						onChange={setFirstName}
						onFocus={() => trackFirstNameInputFocus()}
						type="text"
						value={firstName}
						data-qa="input-first-name"
						id="cardholder-firstName-input"
						isDisabled={disabled}
					/>
				</div>

				<div className="flex-1">
					<TextField
						name="input-last-name"
						errorMessage={validationErrors?.lastName}
						isInvalid={!!validationErrors?.lastName}
						validationBehavior="aria"
						label={labelLastName}
						onChange={setLastName}
						onFocus={() => trackLastNameInputFocus()}
						type="text"
						value={lastName}
						data-qa="input-last-name"
						id="cardholder-lastName-input"
						isDisabled={disabled}
					/>
				</div>
			</div>
		);

	return (
		<div className="flex items-end gap-2">
			<div className="grow">
				<TextField
					name="input-cardholder-name"
					errorMessage={validationErrors?.name}
					isInvalid={!!validationErrors?.name}
					validationBehavior="aria"
					label={labelName}
					onChange={setName}
					onFocus={() => trackNameInputFocus()}
					type="text"
					value={name}
					data-qa="input-cardholder-name"
					id="cardholder-name-input"
					isDisabled={disabled}
				/>
			</div>
		</div>
	);
};
